import { useEffect } from "react";
import { useAuth } from "react-oidc-context";
import { useNavigate } from "react-router-dom";
import { PAGE } from "src/constants/page";
import ClickToCall from "./ClickToCall";

const KeyCloakAuthErrors = () => {
  const auth = useAuth();
  const navigate = useNavigate();
  const handleKeycloakErrors = () => {
    if (auth.error) {
      const keyCloakError = JSON.parse(JSON.stringify(auth?.error) || "");
      if (
        keyCloakError.error === "access_denied" &&
        keyCloakError.error_description ===
          "[REGISTERED] Account is already registered"
      ) {
        navigate("/404", {
          state: {
            keycloakError: true,
            errMsgHeader: "heading_already_activated",
            errMsg1:
              "description_already_activated1",
            errMsg2:
              "description_already_activated2",
            errMsg3:
              "description_already_activated3",
          },
        });
      } else if (
        keyCloakError.error === "unauthorized" &&
        keyCloakError.error_description === "user is blocked"
      ) {
        navigate("/404", {
          state: {
            keycloakError: true,
            errMsgHeader: "heading_inactive",
            errMsg1:
              "description_inactive1",
            errMsg2:
              "description_inactive2",
          },
        });
      } else if (
        keyCloakError.error === "access_denied" &&
        keyCloakError.error_description ===
          "[REGISTRATION_REQUIRED] You must accept the terms and conditions in order to set a new password"
      ) {
        navigate("/404", {
          state: {
            keycloakError: true,
            errMsgHeader: "heading_password_reset",
            errMsg1: "description_password_reset1",
            errMsg2: "description_password_reset2",
            errMsg3: "description_password_reset3",
          },
        });
      } else if (
        keyCloakError.error === "access_denied" &&
        !keyCloakError.isAuthenticated
      ) {
        navigate("/404", {
          state: {
            keycloakError: true,
            errMsgHeader: "heading_login_cancelled",
            errMsg1: "description_login_cancelled",
          },
        });
      } else if (keyCloakError.error === "login_required") {
        navigate(PAGE.LOGIN);
      } else {
        navigate("/404");
      }
    }
  };

  useEffect(() => {
    if (auth.error !== undefined) {
      handleKeycloakErrors();
    }
  }, []);

  return <></>;
};

export default KeyCloakAuthErrors;
